import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSidebar, updateSidebar, setActiveSidebar } from '../actions/SidebarActions';

import { Pane, Heading, Button, Badge } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import SidebarForm from '../components/SidebarForm';

import Configuration from '../Config';

const validation = Configuration.Validations.sidebar;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditSidebar extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getSidebar(this.id));
    }

    handleSave = (values) => {
        this.props.dispatch(updateSidebar(this.props.sidebar.id, values));
    }

    handleSetActive = () => {
        if (window.confirm('Esti sigur ca vrei sa activezi acest sidebar?')) {
            this.props.dispatch(setActiveSidebar(this.id));
        }
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex" alignItems="center">
                    <Pane>
                        <Link to="/sidebar">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista sidebar
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16}>
                        <Link to={`/sidebar/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>

                    {!this.props.sidebar?.active && (
                        <Pane marginLeft={16}>
                            <Button 
                                iconBefore="tick-circle" 
                                intent="success"
                                onClick={this.handleSetActive}
                            >
                                Seteaza ca Activ
                            </Button>
                        </Pane>
                    )}

                    {this.props.sidebar?.active && (
                        <Pane marginLeft={16}>
                            <Badge color="green" size={300}>SIDEBAR ACTIV</Badge>
                        </Pane>
                    )}
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Sidebar: {this.props.sidebar?.name}
                    </Heading>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <SidebarForm
                            isEdit={true}
                            initialValues={{
                                ...this.props.sidebar,
                                definition: typeof this.props.sidebar?.definition === 'string' 
                                    ? JSON.parse(this.props.sidebar.definition)
                                    : this.props.sidebar?.definition
                            }}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors} />
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.sidebar.errors.type === 'validation' ? mapValidationErrors(state.sidebar.errors.fields) : [],
        sidebar: state.sidebar.current
    }
}

export default connect(mapStateToProps)(EditSidebar);
